import { render, staticRenderFns } from "./PaymentEdit.vue?vue&type=template&id=23d72896&"
import script from "./PaymentEdit.vue?vue&type=script&lang=js&"
export * from "./PaymentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports